import { Accordion, AccordionDetails, AccordionSummary, Divider, Stack, Typography, alpha } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import * as React from "react";
import { ArrowDownIcon } from "src/components/ui/svgIcon/CustomIcons";
import DownloadFile from "../form/manage-file-image/DownloadFile";

export default function FAQAccardion({
  question,
  answers,
  index,
  selectedQuestionAnswer,
  setSelectedQuestionAnswer,
  questionId,
}) {
  const theme = useTheme();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const content = `panel${index}bh-content`;
  const header = `panel${index}bh-header`;

  const handlerSelectAnswer = (answer, question) => {
    if (setSelectedQuestionAnswer && selectedQuestionAnswer) {
      setSelectedQuestionAnswer(
        answer === selectedQuestionAnswer?.answer ? null : { answer: answer, question: question }
      );
    }
  };

  return (
    <>
      <Accordion
        expanded={expanded === `panel${index}`}
        onChange={handleChange(`panel${index}`)}
        sx={{
          position: "unset !important",
          minWidth: "unset !important",
          backgroundColor: "transparent !important",
          "&.Mui-expanded": {
            boxShadow: "none",
          },
        }}
      >
        <AccordionSummary
          expandIcon={<ArrowDownIcon color={theme.palette.primary.main} />}
          aria-controls={content}
          id={header}
        >
          <Typography variant="body1" fontWeight="fontWeightMedium" textAlign={"left"}>
            {question}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          {answers?.edges?.map((item) => (
            <Stack key={item?.node?.id}>
              <Stack
                p={2}
                my={1}
                onClick={() => {
                  handlerSelectAnswer(item?.node?.id, questionId);
                }}
                sx={{
                  cursor: selectedQuestionAnswer?.answer === item?.node?.id ? "pointer" : "default",
                  bgcolor:
                    selectedQuestionAnswer?.answer === item?.node?.id
                      ? alpha(theme.palette.primary.main, 0.5)
                      : "transparent",
                  borderRadius: 2,
                }}
              >
                <Typography
                  variant="body1"
                  color={
                    selectedQuestionAnswer?.answer === item?.node?.id ? theme.palette.primary.main : "text.secondary"
                  }
                  sx={{
                    textAlign: "left",
                  }}
                >
                  &bull; {item?.node?.text}
                </Typography>

                {item?.node?.fileUrl && (
                  <Stack width="100%" p={1.5} sx={{ borderRadius: 1.5 }} alignItems="start" justifyContent="center">
                    <DownloadFile file={item?.node?.file} fileUrl={item?.node?.fileUrl} />
                  </Stack>
                )}
              </Stack>
            </Stack>
          ))}
        </AccordionDetails>
      </Accordion>
    </>
  );
}
